import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                AuthContext: "MANIKAPP",
                AuthEntityID: "16395",
                AuthEntityHandle: "ANJAANONE",
                PortalContext: sessionStorage.getItem("PortalIdentifier"),
                PortalDS: sessionStorage.getItem("PortalDS")
            }
        });
        return next.handle(request);
    }
}